import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/serviceSalesSaga";
import ReactDatePicker from "../../../../components/reactDatePicker/reactDatePicker";
import { useDateFormat } from "../../../../hooks/useDateFormat";

const DatePicker = () => {
  const dispatch = useDispatch();
  const dateFormat = useDateFormat();

  const { startDate, endDate } = useSelector((state) => state.serviceSales.selectedRequestDates);
  const { calendarStartDate, calendarEndDate } = useSelector(
    (state) => state.serviceSales.currentUser
  );

  return (
    <ReactDatePicker
      displayFormat={dateFormat}
      startDate={startDate}
      endDate={endDate}
      calendarEndDate={calendarEndDate}
      isRangePicker
      showDefaultInputIcon={false}
      minDate={calendarStartDate}
      updateDates={(startDate, endDate) =>
        dispatch(actionCreators.updateDates({ startDate: startDate, endDate: endDate }))
      }
    />
  );
};

export default DatePicker;
